import React, { useMemo } from "react";

const SurveySelectRange = ({
  id,
  numDegree,
  setAnswersList,
  answersList,
  minDegreeLabel,
  maxDegreeLabel,
}) => {
  const answerIdx = useMemo(
    () => answersList.findIndex((item) => item.questionId === id),
    [answersList, id]
  );

  const answer = useMemo(
    () => (answerIdx >= 0 ? answersList[answerIdx].answers[0].degree : null),
    [answerIdx, answersList]
  );

  const saveAnswer = (degree) => {
    if (answerIdx === -1) {
      let newScreenAnswersList = answersList;
      newScreenAnswersList.push({
        answers: [
          {
            degree: degree,
          },
        ],
        questionId: id,
      });

      setAnswersList([...newScreenAnswersList]);
    } else {
      let newScreenAnswersList = answersList;
      newScreenAnswersList[answerIdx] = {
        answers: [
          {
            degree: degree,
          },
        ],
        questionId: id,
      };

      setAnswersList([...newScreenAnswersList]);
    }
  };

  return (
    <div className="slide-container">
      <p className="slide-txt">{minDegreeLabel}</p>
      <p className="slide-txt">{maxDegreeLabel}</p>
      <div className="range">
        <input
          id={`slider-${id}`}
          type="range"
          min={1}
          max={numDegree}
          step={1}
          className="slider"
          onChange={(e) => saveAnswer(parseInt(e.target.value))}
          value={answer ? answer : numDegree / 2}
        />
        <div className="sliderticks">
          {Array.from(Array(numDegree), (_, i) => (
            <p key={i}></p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SurveySelectRange;
